/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebneedname3Inputs */

const en_placewebneedname3 = /** @type {(inputs: Placewebneedname3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The place needs a name.`)
};

const de_placewebneedname3 = /** @type {(inputs: Placewebneedname3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Ort braucht einen Namen.`)
};

/**
* | output |
* | --- |
* | "The place needs a name." |
*
* @param {Placewebneedname3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebneedname3 = /** @type {((inputs?: Placewebneedname3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebneedname3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebneedname3(inputs)
	return de_placewebneedname3(inputs)
});
export { placewebneedname3 as "placeWebNeedName" }